import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';
import {
  convertFetchTagListResponse,
  type FetchTagListResponseItem,
} from './converters';

const tagService = {
  // NOTE: The GET response has only 1-level tags which do not have parent
  fetchTagMap: async (
    workspaceAlias: string,
    isPublic?: boolean,
  ): Promise<TagMapT> => {
    try {
      const url = isPublic
        ? `/workspaces/${workspaceAlias}/labels/public`
        : `/workspaces/${workspaceAlias}/labels`;
      const res = await defaultAxios.get<FetchTagListResponseItem[]>(url);
      return convertFetchTagListResponse(res.data);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  postTag: async (parentTagAlias: string, name: string, color: number) => {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.post(
        `/workspaces/${wa}/labels/${parentTagAlias}`,
        {
          name,
          color,
        },
      );

      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  deleteTag: async (tagAlias: string) => {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.delete(
        `/workspaces/${wa}/labels/${tagAlias}`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  changeTagColor: async (alias: string, color: number) => {
    const res = await defaultAxios.patch(`/labels/${alias}/color`, { color });
    return res.data;
  },
  changeTagName: async (alias: string, name: string) => {
    const res = await defaultAxios.patch(`/labels/${alias}/name`, { name });
    return res.data;
  },
};

export default tagService;
